import { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { getSuperAdminRegistrationAlerts } from '../../../redux/api';

const SEEN_KEY = 'sa_reg_alerts_seen_at';

const SuperAdminAlerts = () => {
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const run = async () => {
      try {
        const lastSeen = localStorage.getItem(SEEN_KEY) || '';
        const response = await getSuperAdminRegistrationAlerts(lastSeen || undefined);
        const { newCompanies = [], unfinishedSignups = [] } = response.data || {};

        if (newCompanies.length === 1) {
          const company = newCompanies[0];
          toast.success(
            `Nova registracija: ${company.companyName || company.email}`,
            { autoClose: 8000 }
          );
        } else if (newCompanies.length > 1) {
          toast.success(`Imate ${newCompanies.length} novih registrovanih kompanija`, {
            autoClose: 8000
          });
        }

        if (unfinishedSignups.length === 1) {
          toast.info(
            `Neko je uneo email na registraciji, ali nije završio: ${unfinishedSignups[0].email}`,
            { autoClose: 10000 }
          );
        } else if (unfinishedSignups.length > 1) {
          toast.info(
            `${unfinishedSignups.length} ljudi je unelo email na registraciji, a nije završilo`,
            { autoClose: 10000 }
          );
        }

        localStorage.setItem(SEEN_KEY, new Date().toISOString());
      } catch {
        // ignore — dashboard still works
      }
    };

    run();
  }, []);

  return null;
};

export default SuperAdminAlerts;
